// Version und Build-Info der Anwendung
export const APP_VERSION = {
  version: '2.1.0',
  buildDate: new Date().toISOString().split('T')[0],
  buildTime: new Date().toISOString().split('T')[1].split('.')[0],
  buildNumber: Date.now().toString().slice(-6), // Letzte 6 Ziffern vom Timestamp
  features: [
    'SSL/HTTPS Support',
    'Persistent Login',
    'Schichtplanung Fix',
    'Versionsanzeige'
  ]
};

export const getBuildInfo = () => {
  return `v${APP_VERSION.version} (Build ${APP_VERSION.buildNumber}) - ${APP_VERSION.buildDate} ${APP_VERSION.buildTime}`;
};
